import { render, staticRenderFns } from "./PromoStudents.vue?vue&type=template&id=399deebe&scoped=true"
import script from "./PromoStudents.vue?vue&type=script&lang=js"
export * from "./PromoStudents.vue?vue&type=script&lang=js"
import style0 from "./PromoStudents.vue?vue&type=style&index=0&id=399deebe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399deebe",
  null
  
)

export default component.exports